import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await api.get('/auth/me');
        setUser(response.data);
      } catch (error) {
        console.error('Auth check failed:', error);
        // Only clear the token on 401 (invalid/expired token).
        // 403 means the token is valid but the user lacks permission — keep the token.
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
        }
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    console.log('[AUTH] Calling /auth/login API...');
    const response = await api.post('/auth/login', { email, password });
    console.log('[AUTH] API response:', response.data);
    console.log('[AUTH] access_token exists:', !!response.data.access_token);
    console.log('[AUTH] user object:', response.data.user);
    localStorage.setItem('token', response.data.access_token);
    console.log('[AUTH] Token saved to localStorage');
    setUser(response.data.user);
    return response.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  // Expose a refresh function for manual session refresh
  const refreshSession = () => checkAuth();

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);